import type { ClientPropertyHouseDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { mapPropertyToBuildingForm } from "web_myplann/Portfolio/Forms/BuildingShared/mapPropertyToBuildingForm";
import type { HouseFormInput } from "web_myplann/Portfolio/Forms/HouseForm/houseFormSchema";

export const mapPropertyToHouseForm = (
	property: ClientPropertyHouseDetailResponseDTO,
): HouseFormInput =>
	mapPropertyToBuildingForm(property, property.numberOfFloors);
